import React from "react";
import { CheckCircle2, Megaphone, Plus, Upload, X } from "lucide-react";
import { PageHeader } from "src/stage/StageUi";

// AUTO-WA-39: the shared Stage page header, like every other WhatsApp page.
function ContactsHeader({
  totalContacts = 0,
  selectedCount = 0,
  onAddContact,
  onImport,
  loading = false,
  onBroadcastSelected,
  onClearSelection,
}) {
  return (
    <PageHeader
      eyebrow="Reach"
      title="Contacts"
      description="Everyone who can get your WhatsApp messages, with their tags and chat history."
      actions={(onImport || onAddContact) && (
        <>
          {onImport && (
            <button type="button" className="ws-btn ws-btn--quiet" disabled={loading} onClick={() => onImport?.()}>
              <Upload size={15} />Import
            </button>
          )}
          {onAddContact && (
            <button type="button" className="ws-btn ws-btn--primary" disabled={loading} onClick={() => onAddContact?.()}>
              <Plus size={16} />Add contact
            </button>
          )}
        </>
      )}
    >
      <div className="wa-header-facts">
        <span className="ws-chip"><strong className="ws-num">{Number(totalContacts).toLocaleString("en-IN")}</strong> people</span>
        {selectedCount > 0 && (
          <span className="wa-selection" role="status">
            <CheckCircle2 size={14} aria-hidden="true" />{selectedCount} selected
            {onBroadcastSelected && <button type="button" className="ws-btn ws-btn--primary ws-btn--sm" onClick={onBroadcastSelected}><Megaphone size={14} />Send a broadcast</button>}
            {onClearSelection && <button type="button" className="ws-btn ws-btn--plain ws-btn--sm" onClick={onClearSelection}><X size={13} />Clear</button>}
          </span>
        )}
      </div>
    </PageHeader>
  );
}

export default ContactsHeader;
